<template>
  <div>
    <el-radio-group
      v-model="inputType"
      size="small"
    >
      <el-radio-button label="1">
        单行
      </el-radio-button>
      <el-radio-button label="2">
        数字
      </el-radio-button>
      <!-- <el-radio-button label="3">手机号码</el-radio-button> -->
      <el-radio-button label="4">
        多行
      </el-radio-button>
    </el-radio-group>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpInputType',
  mixins: [mixin],
  props: {},
  data () {
    return {
      inputType: '1'
    }
  }
}
</script>
<style scoped lang="scss"></style>
